export default "__VITE_ASSET__DgsZ5NlT__"